
/* Horaires exceptionnels des soirs de match, lus par le statut « Ouvert · ferme à … » du site */
window.woodysLate = function(){
  var cal = [], f;
  try { cal = JSON.parse(document.getElementById('mt-cal').textContent); f = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', hourCycle:'h23'}); } catch(e){ return null; }
  function parts(t){ var p = {}; f.formatToParts(new Date(t)).forEach(function(x){ p[x.type] = x.value; }); return p; }
  var now = Date.now(), a = parts(now), b = parts(now - 864e5), today = a.year + '-' + a.month + '-' + a.day, yday = b.year + '-' + b.month + '-' + b.day, r = {today:null, yesterday:null};
  cal.forEach(function(m){
    if (!m.closeIso || !m.late) return;
    var c = parts(Date.parse(m.closeIso)), mins = +c.hour * 60 + +c.minute;
    if (mins < 660) mins += 1440;
    if (m.ko.slice(0, 10) === today) r.today = mins;
    if (m.ko.slice(0, 10) === yday) r.yesterday = mins;
  });
  return r;
};


/* Page « Manger avant le match à Bollaert » : le calendrier pilote tout (tableau d'affichage, billets, barre du bas,
   plan de match). Un match « dure » 2 h : passé ce délai, il disparaît et le suivant prend la main. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var CAL = [];
  try { CAL = JSON.parse(document.getElementById('mt-cal').textContent); } catch(e){}
  var LIVE = 2 * 3600e3;
  /* un match reste « le match du jour » jusqu'à la fermeture du restaurant quand l'après-match est possible
     (horaires exceptionnels des soirs de match), sinon jusqu'à 2 h après le coup d'envoi */
  CAL.forEach(function(m){ m.t = Date.parse(m.ko); m.end = Math.max(m.t + LIVE, m.closeIso ? Date.parse(m.closeIso) : 0); });
  var dayFmt = null;
  try { dayFmt = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris', year:'numeric', month:'2-digit', day:'2-digit'}); } catch(e){}
  function parisDay(t){
    if (dayFmt){ var p = {}; dayFmt.formatToParts(new Date(t)).forEach(function(x){ p[x.type] = x.value; }); return p.year + '-' + p.month + '-' + p.day; }
    var d = new Date(t); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }
  function dayDiff(a, b){ return Math.round((Date.parse(b + 'T12:00:00Z') - Date.parse(a + 'T12:00:00Z')) / 864e5); }
  function current(now){
    for (var i = 0; i < CAL.length; i++){
      var m = CAL[i];
      if (now < m.end) return {m:m, live: now >= m.t && now < m.t + LIVE, post: now >= m.t + LIVE, j: dayDiff(parisDay(now), parisDay(m.t))};
    }
    return null;
  }
  function q(s, r){ return (r || document).querySelector(s); }
  function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
  function txt(el, v){ if (el && el.textContent !== v) el.textContent = v; }

  /* ---- 1. Le tableau d'affichage : chiffres à volets ---- */
  var sb = q('[data-sb]'), FL = {}, intro = !reduce;
  if (sb){
    sb.classList.add('js');
    qa('[data-g]', sb).forEach(function(g){ FL[g.getAttribute('data-g')] = qa('.fl', g); });
  }
  function setFlap(el, v, fast){
    if (el._v === v) return;
    var k = el._k || (el._k = {t: q('.fl-t i', el), b: q('.fl-b i', el), ft: q('.fl-ft i', el), fb: q('.fl-fb i', el)});
    var old = el._v == null ? '0' : el._v; el._v = v;
    if (reduce){ k.t.textContent = k.b.textContent = k.ft.textContent = k.fb.textContent = v; return; }
    k.t.textContent = v; k.fb.textContent = v; k.ft.textContent = old; k.b.textContent = old;
    el.classList.remove('go', 'fast'); void el.offsetWidth; el.classList.add('go'); if (fast) el.classList.add('fast');
    clearTimeout(el._tm);
    el._tm = setTimeout(function(){ k.b.textContent = v; k.ft.textContent = v; el.classList.remove('go', 'fast'); }, fast ? 160 : 560);
  }
  function two(n){ n = Math.max(0, Math.min(99, n)); return (n < 10 ? '0' : '') + n; }
  function digits(left){
    var s = Math.max(0, Math.floor(left / 1000));
    return {d: two(Math.floor(s / 86400)), h: two(Math.floor(s % 86400 / 3600)), m: two(Math.floor(s % 3600 / 60)), s: two(s % 60)};
  }
  function paintClock(left){
    var v = digits(left);
    Object.keys(FL).forEach(function(k){ FL[k].forEach(function(el, i){ setFlap(el, v[k].charAt(i), false); }); });
    var c = q('[data-sb-clock]', sb);
    if (c) c.setAttribute('aria-label', 'Coup d’envoi dans ' + (+v.d) + ' jours, ' + (+v.h) + ' heures et ' + (+v.m) + ' minutes');
  }
  /* à l'arrivée : les chiffres défilent comme un panneau de gare, puis se posent */
  function runIntro(left){
    var v = digits(left), all = [];
    ['d', 'h', 'm', 's'].forEach(function(k){ (FL[k] || []).forEach(function(el, i){ all.push({el:el, to:v[k].charAt(i)}); }); });
    var done = 0;
    all.forEach(function(o, n){
      var steps = 4 + n, i = 0;
      setTimeout(function step(){
        if (i < steps){ setFlap(o.el, String((+o.to + steps - i) % 10), true); i++; setTimeout(step, 150); }
        else { setFlap(o.el, o.to, false); if (++done === all.length) setTimeout(function(){ intro = false; }, 600); }
      }, 500 + n * 70);
    });
  }
  function paintBoard(now){
    if (!sb) return null;
    var c = current(now), K = q('[data-sb-k]', sb), M = q('[data-sb-match]', sb), T = q('[data-sb-meta]', sb), P = q('[data-sb-tip]', sb), C = q('[data-sb-clock]', sb), L = q('[data-sb-live]', sb);
    if (!c){
      txt(K, '[ Saison terminée à Bollaert ]'); txt(M, 'Rendez-vous en août'); txt(T, 'Le calendrier de la saison prochaine arrive cet été.');
      P.hidden = true; C.hidden = true; L.hidden = true; return null;
    }
    var m = c.m;
    txt(M, 'Lens – ' + m.opp);
    txt(T, m.comp + ' · ' + (m.ok ? m.date + ' · ' + m.h : m.wk + ' · horaire à confirmer'));
    sb.classList.toggle('tbc', !m.ok);
    P.hidden = false;
    if (c.post){
      txt(K, '[ Ce soir chez Woody’s ]'); L.hidden = false; txt(L, 'Après le match'); C.hidden = true;
      var pt = 'Le match est fini\u00a0? On vous attend jusqu’à ' + m.close + ', à 4 minutes à pied du stade.';
      if (P.textContent !== pt) P.textContent = pt;
    } else if (c.live){
      txt(K, '[ En ce moment à Bollaert ]'); L.hidden = false; txt(L, 'Match en cours'); C.hidden = true;
      var lt = m.after ? 'Bon match ! On vous attend après le coup de sifflet final, jusqu’à ' + m.close + '.' : 'Bon match ! On se retrouve au prochain.';
      if (P.textContent !== lt) P.textContent = lt;
    } else {
      txt(K, c.j === 0 ? '[ Ce soir à Bollaert ]' : '[ Prochain match à Bollaert ]');
      L.hidden = c.j !== 0; txt(L, 'Jour de match'); C.hidden = false;
      var tip = m.ok ? (m.after ? 'Notre conseil : à table à <b>' + m.tip + '</b>, au stade à ' + m.go + '. Et après le match, on vous attend jusqu’à ' + m.close + '.' : 'Notre conseil : à table chez Woody’s à <b>' + m.tip + '</b>, au stade à ' + m.go + '.') : 'L’horaire est fixé par la Ligue quelques semaines avant le match : notre conseil arrivera avec lui.';
      if (P._h !== tip){ P.innerHTML = tip; P._h = tip; }
    }
    return c;
  }

  /* ---- 2. Les billets : matchs passés masqués, prochain en rouge, mois, flèches ---- */
  var rail = q('[data-tkrail]');
  function paintTickets(now){
    if (!rail) return;
    var c = current(now), vis = 0, months = {};
    qa('.tk', rail).forEach(function(li){
      var cl = li.getAttribute('data-close'), gone = now >= Math.max(Date.parse(li.getAttribute('data-ko')) + LIVE, cl ? Date.parse(cl) : 0);
      if (li.hidden !== gone) li.hidden = gone;
      var next = !!(c && li.getAttribute('data-id') === c.m.id);
      li.classList.toggle('is-next', next);
      var f = q('.tk-flag', li); if (f) txt(f, next ? (c.post ? 'Après le match' : c.live ? 'En cours' : c.j === 0 ? 'Ce soir' : 'Prochain match') : '');
      if (!gone){ vis++; if (!months[li.getAttribute('data-m')]) months[li.getAttribute('data-m')] = li; }
    });
    qa('[data-month]').forEach(function(b){ b.parentNode.hidden = !months[b.getAttribute('data-month')]; });
    txt(q('[data-tk-n]'), vis + (vis > 1 ? ' matchs' : ' match'));
    var em = q('[data-tk-empty]'); if (em) em.hidden = vis > 0;
    rail.hidden = vis === 0;
  }
  function padL(){ return parseFloat(getComputedStyle(rail).paddingLeft) || 0; }
  function scrollRail(x){ rail.scrollTo({left: x, behavior: reduce ? 'auto' : 'smooth'}); }
  if (rail){
    qa('[data-month]').forEach(function(b){
      b.addEventListener('click', function(){
        var li = q('.tk[data-m="' + b.getAttribute('data-month') + '"]:not([hidden])', rail);
        if (li) scrollRail(li.offsetLeft - padL());
      });
    });
    var step = function(){ var li = q('.tk:not([hidden])', rail); return li ? li.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 16) : 360; };
    var prev = q('[data-tk-prev]'), next = q('[data-tk-next]');
    if (prev) prev.addEventListener('click', function(){ rail.scrollBy({left: -step() * 2, behavior: reduce ? 'auto' : 'smooth'}); });
    if (next) next.addEventListener('click', function(){ rail.scrollBy({left: step() * 2, behavior: reduce ? 'auto' : 'smooth'}); });
    var onRail = function(){
      var x = rail.scrollLeft + padL() + 8, cur = null;
      qa('.tk:not([hidden])', rail).forEach(function(li){ if (!cur || li.offsetLeft <= x) cur = li; });
      qa('[data-month]').forEach(function(b){ b.setAttribute('aria-current', String(!!cur && b.getAttribute('data-month') === cur.getAttribute('data-m'))); });
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
    };
    rail.addEventListener('scroll', function(){ requestAnimationFrame(onRail); }, {passive:true});
    window.addEventListener('resize', onRail);
    setTimeout(onRail, 60);
    /* molette verticale sur ordinateur : défile le rail sans bloquer la page aux extrémités */
    rail.addEventListener('wheel', function(e){
      if (!fine || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if ((e.deltaY > 0 && rail.scrollLeft < max - 2) || (e.deltaY < 0 && rail.scrollLeft > 2)){ rail.scrollLeft += e.deltaY; e.preventDefault(); }
    }, {passive:false});
  }

  /* ---- Barre du prochain match (ordinateur) et case de la barre mobile ---- */
  var pill = q('[data-pill]'), hero = q('.mt-hero'), foot = q('.site-foot'), heroOut = false, footIn = false;
  var mbm = q('[data-mbm]');
  function paintBars(c){
    if (pill){
      var aft = !!(c && (c.live || c.post) && c.m.after), show = !!(c && (!(c.live || c.post) || aft) && heroOut && !footIn);
      if (show){
        var m = c.m;
        txt(q('[data-pill-k]', pill), aft ? 'Après le match' : c.j === 0 ? 'Ce soir' : c.j === 1 ? 'Demain' : 'Prochain match');
        txt(q('[data-pill-m]', pill), 'Lens – ' + m.opp);
        txt(q('[data-pill-j]', pill), aft ? 'jusqu’à ' + m.close : c.j <= 1 ? (m.ok ? m.h : '') : 'J-' + c.j);
      }
      pill.classList.toggle('on', show);
      pill.setAttribute('aria-hidden', String(!show));
      qa('a', pill).forEach(function(a){ a.tabIndex = show ? 0 : -1; });
    }
    if (mbm){
      var J = q('[data-mbm-j]', mbm), Tt = q('[data-mbm-t]', mbm);
      if (!c){ txt(J, 'Matchs'); txt(Tt, 'Saison terminée'); }
      else if (c.live || c.post){ txt(J, c.m.after ? 'Après' : 'En cours'); txt(Tt, c.m.after ? 'le match · ' + c.m.close : 'Lens – ' + c.m.opp); }
      else if (c.j === 0){ txt(J, 'Ce soir'); txt(Tt, (c.m.ok ? c.m.h + ' · ' : '') + c.m.opp); }
      else { txt(J, c.j === 1 ? 'Demain' : 'J-' + c.j); txt(Tt, 'Lens – ' + c.m.opp); }
    }
  }
  if ('IntersectionObserver' in window){
    if (hero) new IntersectionObserver(function(es){ heroOut = !es[0].isIntersecting; paintBars(current(Date.now())); }, {rootMargin: '-80px 0px 0px 0px'}).observe(hero);
    if (foot) new IntersectionObserver(function(es){ footIn = es[0].isIntersecting; paintBars(current(Date.now())); }).observe(foot);
  }

  /* ---- 4. Plan de match : les heures suivent le prochain match ---- */
  function paintPlan(c){
    var m = c && c.m;
    if (m && m.ok){
      txt(q('[data-pt="tip"]'), 'À table à ' + m.tip);
      txt(q('[data-pt="go"]'), 'Au stade à ' + m.go);
      txt(q('[data-pt-lead]'), 'Pour Lens – ' + m.opp + ', coup d’envoi à ' + m.h + '\u00a0: trois passes, et vous êtes au stade à l’heure.');
    } else {
      txt(q('[data-pt="tip"]'), 'À table 1\u00a0h\u00a030 avant');
      txt(q('[data-pt="go"]'), 'Au stade 30\u00a0min avant');
      txt(q('[data-pt-lead]'), (m ? 'Pour Lens – ' + m.opp + ', horaire à confirmer' : 'Pour chaque match à Bollaert') + '\u00a0: trois passes, et vous êtes au stade à l’heure.');
    }
  }

  /* ---- Battement : chaque seconde ---- */
  var lastMin = -1;
  function tick(){
    var now = Date.now(), c = paintBoard(now);
    if (c && !c.live && !c.post && !intro) paintClock(c.m.t - now);
    var mn = Math.floor(now / 60000);
    if (mn !== lastMin){ lastMin = mn; paintTickets(now); paintPlan(c); }
    paintBars(c);
  }
  var c0 = paintBoard(Date.now());
  if (c0 && !c0.live && !c0.post){ if (intro) runIntro(c0.m.t - Date.now() - 2200); else paintClock(c0.m.t - Date.now()); }
  else intro = false;
  tick(); setInterval(tick, 1000);
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) tick(); });

  /* ---- 3. La compo : les cartes se retournent (survol sur ordinateur, toucher sur téléphone) ---- */
  qa('.pc').forEach(function(card){
    var btns = qa('[data-flip]', card);
    function set(on){ card.classList.toggle('flipped', on); btns.forEach(function(b){ b.setAttribute('aria-expanded', String(on)); }); }
    btns.forEach(function(b){ b.addEventListener('click', function(e){ e.stopPropagation(); set(!card.classList.contains('flipped')); }); });
    card.addEventListener('click', function(e){ if (e.target.closest('a,button')) return; set(!card.classList.contains('flipped')); });
    card.addEventListener('focusin', function(e){ if (e.target.closest('.pc-back')) set(true); });
    card.addEventListener('mouseleave', function(){ if (fine) set(false); });
  });

  /* ---- Apparitions au défilement (une fois) ---- */
  function onView(el, fn, opt){
    if (!el) return;
    if (!('IntersectionObserver' in window)){ fn(); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ io.disconnect(); fn(); } }); }, opt || {threshold: .35});
    io.observe(el);
  }

  /* ---- 4. Le tableau tactique : les flèches se tracent ---- */
  var board = q('[data-board]');
  if (board && !reduce){
    qa('.tb-line', board).forEach(function(p){ var L = 400; try { L = Math.ceil(p.getTotalLength()) + 2; } catch(e){} p.style.setProperty('--len', L); });
    board.classList.add('js');
    onView(board, function(){ board.classList.add('in'); }, {threshold: .45});
  }

  /* ---- 5. Le trajet se dessine, le chrono défile de 0'00 à 4'00 ---- */
  var map = q('[data-map]');
  if (map){
    var route = q('.mm-route', map), mask = q('.mm-reveal', map), walker = q('.mm-walker', map), clock = q('[data-clock]', map), badge = q('.mm-badge', map);
    var RL = route.getTotalLength();
    function draw(p){
      mask.style.strokeDasharray = RL + ' ' + RL; mask.style.strokeDashoffset = (RL * (1 - p)).toFixed(1);
      var pt = route.getPointAtLength(RL * p); walker.setAttribute('cx', pt.x.toFixed(1)); walker.setAttribute('cy', pt.y.toFixed(1));
      var s = Math.round(240 * p); clock.textContent = Math.floor(s / 60) + '\'' + ('0' + s % 60).slice(-2);
    }
    if (reduce){ draw(1); badge.classList.add('on'); }
    else {
      draw(0);
      onView(map, function(){
        var t0 = null, D = 2600;
        function fr(t){
          if (t0 === null) t0 = t;
          var x = Math.min(1, (t - t0) / D), e = x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
          draw(e);
          if (x < 1) requestAnimationFrame(fr); else badge.classList.add('on');
        }
        requestAnimationFrame(fr);
      }, {threshold: .55});
    }
  }

  /* ---- 8. Fin : The 1976 sort du coin ---- */
  var end = q('[data-end]');
  if (end){ end.classList.add('js'); onView(end, function(){ end.classList.add('in'); }, {threshold: .25}); }
})();

